import type { ReactNode } from 'react';
import OnelivePageLayout from './OnelivePageLayout';
import OneliveMobileMembersPanel from './OneliveMobileMembersPanel';

interface Props {
  children?: ReactNode;
  pageClassName?: string;
}

export default function OneliveMobileMypageShell({ children, pageClassName }: Props) {
  const pageClass = ['onelive-mobile-mypage-page', pageClassName].filter(Boolean).join(' ');

  return (
    <OnelivePageLayout pageClassName={pageClass}>
      <div className="onelive-ref-sub-title"><span>마이페이지</span></div>
      <section className="onelive-members-wrap">
        <OneliveMobileMembersPanel>{children}</OneliveMobileMembersPanel>
      </section>
    </OnelivePageLayout>
  );
}
